<template>
  <div id="quick-tour-onboarding">
    <modal width="460px" name="quick-tour-onboarding-modal">
      <div class="modal-text">
        <a class="close" @click="hide">X Close</a>
        <h3 class="header"><b>{{ content.header }}</b></h3>
        <p v-html="content.content" class="content"></p>
      </div>
      <b-button class="hide-quick-tour-btn" @click="hideQuickTour">Don't show this again</b-button>
      <div class="modal-arrow"></div>
    </modal>
  </div>
</template>

<script>
import TMGeneralButton from "../common/TMGeneralButton.vue";
import { mapActions, mapState, mapGetters } from "vuex";
import Api from "@/services/api";
import { getAuthorizationToken } from "@/services/utils";

export default {
  components: { TMGeneralButton },
  name: "quickTourOnBoarding",
  data() {
    return {

    };
  },
  computed: {
    ...mapState(["currentUser"]),
    ...mapGetters(["isGroupManager"]),
    content() {
      if (this.currentUser) {
        if (this.currentUser.admin) {
          return {
            header: 'Take a Quick Tour',
            content: 'Learn about TorchMetrics with 3 Quick Tours.<br>1. <b>Organizational Admin:</b> See all the things you can do.<br>2. <b>Group Manager:</b> See what the group manager you assign can do.<br>3. <b>Presenter:</b> Look at what presenters can do.'
          };
        } else if (this.isGroupManager) {
          return {
            header: 'Take a Quick Tour',
            content: 'Learn about TorchMetrics with 2 Quick Tours.<br>1. <b>Group Manager:</b> See all the things you can do.<br>2. <b>Presenter:</b> Look at what presenters can do.'
          };
        } else {
          return {
            header: 'Take a Quick Tour',
            content: 'Learn about using TorchMetrics to transform yourself into a more confident and persuasive presenter.'
          };
        }
      } else {
        return {};
      }
    }
  },
  methods: {
    ...mapActions(["UPDATE_ONBOARDING"]),
    show() {
      this.$modal.show("quick-tour-onboarding-modal");
    },
    hide() {
      this.$modal.hide("quick-tour-onboarding-modal");
    },
    hideQuickTour() {
      Api().post("users/hide_quick_tour_popup", {
        user_id: this.currentUser.id,
        headers: {
          Authorization: getAuthorizationToken(),
        },
      })
      .then(res => {
        this.currentUser.show_quick_tour_popup = false;
        window.localStorage.setItem("currentUser", JSON.stringify(this.currentUser))
        this.$modal.hide("quick-tour-onboarding-modal");
      })
      .catch((err) => {
        console.log(err);
      });
    }
  },
  mounted() {
    if (this.currentUser.show_quick_tour_popup) {
      this.show();
    }
  },
};
</script>
<style lang="less">
@import "../../assets/components/onBoarding/onBoarding.less";
</style>
